import React from 'react';

import { CheckboxWithLabel } from '@depop/web-ui-kit/CheckboxWithLabel';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { MobileFilterFooter } from '../MobileFilterFooter';
import { MobileFilterHeader } from '../MobileFilterHeader';
import { SearchFilterTrigger } from '../SearchFilterTrigger';
import baseFilterStyles from '../baseFilterStyles.module.css';

import styles from './styles.module.css';

import { Dropdown } from '@/components/Dropdown';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCategoryFilters } from '@/modules/categories/useCategoryFilters';
import { FilterTypes } from '@/modules/filters/types';
import { getTranslationFromPrefix } from '@/modules/localisation/helper';
import { useSearchFilters } from '@/modules/search/useSearchFilters';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  closeMobileFilterDrawer: () => void;
  sellerId?: number;
};

export function SubcategoryFilter({
  closeMobileFilterDrawer,
  sellerId,
}: Props) {
  const { searchFilters, setSearchFilters } = useSearchFilters();
  const t = useTranslations('common');
  const title = t('Subcategory');
  const { data } = useCategoryFilters();
  const [, user] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({ userId: user?.id });

  if (!data || !searchFilters.groups) {
    return null;
  }

  const subcategoryOptions = data?.data.groups[searchFilters.groups];

  if (!subcategoryOptions) {
    return null;
  }

  return (
    <Dropdown
      TriggerComponent={(props) => (
        <SearchFilterTrigger
          {...props}
          isActive={
            searchFilters.productTypes && searchFilters.productTypes.length > 0
          }
          title={title}
        />
      )}
      onOpen={() =>
        sendActivityTrackerEvent(
          ActivityTrackerEventType.FILTER_OPENED_ACTION,
          { filterType: FilterTypes.Subcategory }
        )
      }
    >
      {({ className, toggleDropdown }) => {
        return (
          <div
            className={clsx(
              className,
              baseFilterStyles.searchFilterDropdownContents,
              styles.categoryFilterDropdownContents
            )}
          >
            <MobileFilterHeader
              title={title}
              toggleDropdown={toggleDropdown}
              closeMobileFilterDrawer={closeMobileFilterDrawer}
            />
            <div className={baseFilterStyles.content}>
              {subcategoryOptions.map(({ id, name }) => (
                <CheckboxWithLabel
                  className={clsx(
                    baseFilterStyles.searchFilterCheckbox,
                    styles.subcategoryCheckbox
                  )}
                  key={name}
                  label={getTranslationFromPrefix(name, t, 'Subcategories')}
                  align="left"
                  value={`category-${id}`}
                  onChange={() => setSearchFilters.setProductTypeFilter(id)}
                  checked={searchFilters.productTypes?.includes(id)}
                />
              ))}
            </div>
            <MobileFilterFooter
              handleSubmit={closeMobileFilterDrawer}
              handleClear={() => setSearchFilters.setProductTypeFilter()}
              sellerId={sellerId}
            />
          </div>
        );
      }}
    </Dropdown>
  );
}
